module.exports = __webpack_public_path__ + "img/wyeth-print-gallery.1dea3e60.jpg";